<template>
  <div class="content">
    <navigator title="报修申请"></navigator>
    <van-cell-group>
      <van-field label="单元编码" v-model="unitCode" placeholder="请填写单元编码" />
    </van-cell-group>
    <van-cell-group class="list">
      <van-cell title="物料明细" class="stuff-title" />
      <div v-for="(item, index) in stuffList" :key="index">
        <van-cell :title="'物料'+ Number(index+1)" class="top" >
          <div class="del" @click="onDel(index)" v-show="stuffList.length > 1">X</div>
        </van-cell>
        <van-cell title="物料名称" v-model="item.stuff" is-link @click="item.showPicker = true; titleIndex = index"/>
        <van-picker class="picker" v-show="item.showPicker" :columns="titleList" show-toolbar
          @change="onChange"
          title="请选择"
          @cancel="onCancel(index)"
          @confirm="onConfirm"
        />
        <van-field label="金额（元）" type="number" v-model="item.fee" placeholder="请填写金额" @change="countPrice" />
        <van-cell title="数量" class="bottom" >
          <van-stepper v-model="item.num" @change="countPrice" />
        </van-cell>
      </div>
    </van-cell-group>
    <div class="add" @click="onAdd" v-show="stuffList.length !== titleList.length"><van-icon name="add-o" /> 添加</div>
    <van-cell-group>
      <van-field label="备注说明" v-model="bidRemark" class="remark" placeholder="请输入备注说明" />
    </van-cell-group>
    <van-submit-bar class="btn"
      :price="allPrice"
      button-text="提交"
      @submit="onSubmit"
    />
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import { Toast, Dialog } from 'vant';
import { jsTimestampFilter } from '@/utils/filters.js';
import deepcopy from '@/utils/deepcopy';

export default {
  data() {
    return {
      titleIndex: 0,
      title: '请选择',
      showPicker: false,
      unitCode: '',
      orderId: '',
      bidRemark: '',
      stuffList: [{stuff:'',fee:0,num:1, showPicker:false,materielId:''}],
      allPrice: 0,
      titleList: [{text: '', disabled: true}],
      materielList: [{fee:'', materielId:'',num:''}],
    }
  },
  created () {
    this.orderId = this.$route.params.orderId
    this.unitCode = this.$route.query.unit_code
  },
  computed: {
    ...mapGetters(['currentParkId', 'token', 'parkServiceList']),
  },
  mounted() {
    this.$http.post(`${this.URL_PREFIX}/app/get/maintain/materiel/info/list`,{
      parkId: this.currentParkId
    },{
        headers: { token: this.token },
    }).then((res) => {
      if(res.data.resCode==10000){
        this.titleList = res.data.resData.pageList.map((p) => p.materielTitle+"+"+p.materielId)
        .map((k) => {
          let obj = {};
          obj.text = k.split('+')[0];
          obj.materielId = k.split('+')[1];
          obj.disable = true;
          return obj
        });
        this.stuffList[0].stuff = this.titleList[0].text
        this.stuffList[0].materielId = this.titleList[0].materielId
      }
    })
  },
  methods: {
    onDel(index){
      this.stuffList.splice(index,1)
    },
    onAdd(){
      const newOne = {stuff:this.titleList[0].text, materielId:this.titleList[0].materielId, fee:0, num: 1,showPicker:false}
      this.stuffList.push(newOne)
    },
    onChange(picker, value, index){
      this.stuffList[this.titleIndex].stuff = value.text
      this.stuffList[this.titleIndex].materielId = value.materielId
    },
    onConfirm(value, index) {
      this.stuffList[this.titleIndex].showPicker = false
      this.titleList[index].disable = true
      // this.titleList[this.titleIndex].text = value.text
    },
    onCancel(index) {
      this.stuffList[index].showPicker = false
    },
    countPrice() {
      let price = 0;
      this.stuffList.map((v, k)=>{
        price += Number(v.fee)*100;
      })
      this.allPrice = price;
    },
    onSubmit(){
      if(this.allPrice<=0){
        Dialog.confirm({
          title: '提示',
          message: '当前订单金额为0，请确认订单是否无需支付任何费用。'
        }).then(() => {
          this.orderBid();
        }).catch(() => {
          // on cancel
        });
      }else{
        this.orderBid();
      }
    },
    orderBid() {
      let materielList = [];
      this.stuffList.map((v, k)=>{
        materielList.push({
          materielId: v.materielId,
          fee: Number(v.fee)*100,
          num: v.num,
        })
      })
      let params = {
        orderId: this.orderId,
        unitCode: this.unitCode,
      }
      if(materielList.length>0){
        params.materielList = materielList;
      }
      if(this.bidRemark){
        params.bidRemark = this.bidRemark
      }
      this.$http.post(`${this.URL_PREFIX}/app/bid/maintain/order/personnel`, params, {
          headers: { token: this.token },
      }).then((res) => {
        Toast(res.data.resDesc)
        if(res.data.resCode==10000){
          this.$router.push({ path:`/repairer/apply/${this.orderId}`})
        }else{
          Toast('没有选择物料，请联系管理员到后台配置物料信息')
        }
      });
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@scss';
.content{
  background: #efefef;
  .remark{
    min-height: 50px;
    padding-bottom: 70px
  }
  .picker{
    bottom: 0;
  }
  .stuff-title{
    font-weight: 400;
    color: rgba(69,90,100,.6);
  }
  .top{
    font-weight: bold;
  }
  .list{
    margin-top: 8px;
    background: #efefef;
  }
  .bottom{
    margin-bottom: 5px;
  }
  .del{
    color: #888;
  }
  .add{
    padding: 20px 145px;
    font-size: 15px;
    color: #888;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/repairer/Stuff.vue